<template>
    <IframeWindow  v-show="show" :iframe-src="src" :width="800" :height="600"
        :style="{ top: top + 'px', left: left + 'px'}">
        <svg ref="hitArea0" class="move" v-show="hitArea == 0" :style="{ transform: 'scale(' + scale + ')' }">
            <g fill="blue" :fill-opacity="hitAreaAlpha">
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="410" height="39" x="211" y="107"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="70" height="116" x="211" y="146"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="31" height="116" x="359" y="146"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="31" height="116" x="470" y="146"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="75" height="116" x="574" y="146"></rect>

                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="440" height="32" x="211" y="262"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="304" height="41" x="211" y="294"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="86" height="41" x="563" y="294"></rect>

                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="218" height="97" x="211" y="335"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="61" height="97" x="588" y="335"></rect>

                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="171" height="53" x="211" y="432"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="181" height="53" x="469" y="432"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea0, settingDragMargin)" width="87" height="10" x="382" y="475"></rect>
            </g>
        </svg>
        <svg ref="hitArea1" class="move" v-show="hitArea == 1" :style="{ transform: 'scale(' + scale + ')' }">
            <g fill="red" :fill-opacity="hitAreaAlpha">
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea1)" width="800" height="19" x="0" y="0"></rect>

                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea1)" width="625" height="36" x="0" y="18"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea1)" width="28" height="36" x="777" y="17"></rect>

                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea1)" width="800" height="546" x="0" y="53"></rect>

            </g>
        </svg>
        <svg ref="hitArea2" class="move" v-show="hitArea == 2" :style="{ transform: 'scale(' + scale + ')' }">
            <g fill="red" :fill-opacity="hitAreaAlpha">
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea2, countdownDragMargin)" width="800" height="18" x="0" y="203"></rect>

                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea2, countdownDragMargin)" width="625" height="35" x="0" y="220"></rect>
                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea2, countdownDragMargin)" width="28" height="35" x="777" y="220"></rect>

                <rect class="moveable" @pointerdown="startDrag($event, $refs.hitArea2, countdownDragMargin)" width="800" height="98" x="0" y="254"></rect>

            </g>
        </svg>
    </IframeWindow>
</template>

<script>
import IframeWindow from './IframeWindow.vue';
import BookData from '../../js/book_data';
import EventBus from '../../js/event_bus';
import DragElem from '../DragElem.vue';
import { transform } from '@vue/compiler-core';
import { store } from '../../store';
import { VIEW_TYPE } from '../../js/view_type';
export default {
    name: "Countdown",
    data: function () {
        return {
            show: false,
            hitArea: 0,
            src: "",
            scale: 1,
            hitAreaAlpha: "0",
            layaScale: 1
        }
    },
    components: {
        IframeWindow
    },
    mixins: [
        DragElem
    ],
    mounted() {
        window.removeEventListener("message", this.receiveMessage);
        const self = this;
        EventBus.getInstance().emitter.on("countdown", function () {
            self.show = true;
            switch (store.nowView) {
                case VIEW_TYPE.ANDROID:
                    self.src = "file:///android_asset/item/countdown/index.html";
                    break;
                case VIEW_TYPE.IOS:
                    self.src = "../item/countdown/index.html";
                    break;
                default:
                    self.src = BookData.Instance.getItemPath() + "countdown/index.html";
                    break;
            }
        })

        window.addEventListener("message", this.receiveMessage);
    },
    methods: {
        receiveMessage(event) {
            const message = event.data.message;
            switch (message) {
                case "closeCountdown":
                    this.show = false;
                    break;
                case "changeHitArea":
                    console.log("change hitArea to", event.data.index);
                    this.hitArea = event.data.index;
                    break;
                case "setScale":
                    console.log(event.data.scale);
                    this.scale = event.data.scale * this.layaScale;
                    break;
                case "layaCanvasTransform":
                    this.layaScale = parseFloat(event.data.value.split("matrix(")[1].split(",")[0]);
                    //console.log("laya scale:", this.layaScale)
                    this.scale = this.layaScale;
                    break;
            }
        }
    },
    computed: {
        settingDragMargin() {
            return {
                top: 101,
                right: 141,
                bottom: 112,
                left: 154
            }
        },
        countdownDragMargin() {
            return {
                top: 203,
                right: 0,
                bottom: 248,
                left: 0
            }
        }
    }
}
</script>

<style scoped>
.move {
    position: absolute;
    width: 800px;
    height: 600px;
    top: 0px;
    left: 0px;
    pointer-events: none;
    /* cursor: move; */
}

.moveable {
    pointer-events: fill;
    cursor: move;
}
</style>